export const USER_LIST_LOADING = 'USER_LIST_LOADING';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
